import _ from 'lodash';
import { dispatchProps } from "../cnr/reducers/reducerHelpers/dispatchProps";

const authGenericTypes = {
  authGeneric: 'authGeneric',
}

export const authFunctionTypes = {
  addAuthToken: 'addAuthToken',
  addProfileTopic: 'addProfileTopic',
  createAuth: 'createAuth',
  createCustomToken: 'createCustomToken',
  createOrUpdateAuth: 'createOrUpdateAuth',
  deleteAuth: 'deleteAuth',
  deleteAuthByEmail: 'deleteAuthByEmail',
  disableAuth: 'disableAuth',
  getAuthByEmail: 'getAuthByEmail',
  getAuthByEmailOrPhoneNumber: 'getAuthByEmailOrPhoneNumber',
  getAuthByPhoneNumber: 'getAuthByPhoneNumber',
  getAuthsByEmail: 'getAuthsByEmail',
  getClientProfiles: 'getClientProfiles',
  getProfile: 'getProfile',
  removeProfileTopic: 'removeProfileTopic',
  updateAuth: 'updateAuth',
  updateAuthByUid: 'updateAuthByUid',
  updateAuthPassword: 'updateAuthPassword',
}

const callFsFunction = async (fsCall, callData, useProd) => {
  const data = await fsCall(authGenericTypes.authGeneric, callData, useProd)
  return data
}

export const fsfn_allAuth = (fsCall) => {
  return {
    addAuthCustomToken: (itemData, callback) => fsfn_addAuthCustomToken(fsCall, itemData, callback),
    addProfileTopic: (itemData, dispatch, dispatchType) => fsfn_addProfileTopic(fsCall, itemData, dispatch, dispatchType),
    createCustomToken: (creds, dispatch) => fsfn_createCustomToken(fsCall, creds, dispatch),
    createOrUpdateAuth: (itemData, dispatch) => fnfs_createOrUpdateAuth(fsCall, itemData, dispatch),
    createOrUpdateAuthAndSignIn: (data) => fsfn_createOrUpdateAuthAndSignIn(fsCall, data),
    deleteAuthByEmail: (itemData, dispatch, callback) => fsfn_deleteAuthByEmail(fsCall, itemData, dispatch, callback),
    deleteAuthByUid: (uid, dispatch, callback) => fsfn_deleteAuthByUid(fsCall, uid, dispatch, callback),
    disableAuth: (uid, itemData, callback) => fsfn_disableAuth(fsCall, uid, itemData, callback),
    getAuthByEmail: (itemData, callback, projectName, useProd) => fsfn_getAuthByEmail(fsCall, itemData, callback, projectName, useProd),
    getAuthByEmailOrPhoneNumber: (itemData, callback) => fsfn_getAuthByEmailOrPhoneNumber(fsCall, itemData, callback),
    getAuthByPhoneNumber: (itemData, callback, projectName) => fsfn_getAuthByPhoneNumber(fsCall, itemData, callback, projectName),
    getAuthsByChunkEmail: (chunks, pathViews, updateDatabase, callback, staticAppUsers) => fsfn_getAuthsByChunkEmail(fsCall, chunks, pathViews, updateDatabase, callback, staticAppUsers),
    getAuthsByEmail: (appUsers, callback) => fsfn_getAuthsByEmail(fsCall, appUsers, callback),
    getClientProfiles: (pathViews, emails, callback) => fsfn_getClientProfiles(fsCall, pathViews, emails, callback),
    getProfileAuth: (profileData, callback) => fsfn_getProfileAuth(fsCall, profileData, callback),
    removeFcm: (authUid, authData, callback) => fsfn_removeFcm(fsCall, authUid, authData, callback),
    removeProfileTopic: (itemData, dispatch, dispatchType) => fsfn_removeProfileTopic(fsCall, itemData, dispatch, dispatchType),
    updateAuth: (itemData, dispatch) => fsfn_updateAuth(fsCall, itemData, dispatch),
    updateAuthByUid: (authUid, authData, callback, projectName) => fsfn_updateAuthByUid(fsCall, authUid, authData, callback, projectName),
    updateAuthPassword: (itemData) => fsfn_updateAuthPassword(fsCall, itemData),
  }
}

/**
 * 
 * @param {*} chunks 
 * @param {function} callback 
 */
const fsfn_getAuthsByChunkEmail = async (fsCall, chunks, pathViews, updateDatabase, callback, appUserAuths) => {
  try {
    const response = await chunkPromise(fsCall, chunks, pathViews, updateDatabase)
    let _found = []
    if (response) {
      response.forEach(item => {
        const { result, success } = item ?? {}
        if (success) {
          const { found } = result ?? {}
          if (found) {
            _found = [..._found, ...found]
          }
        }
      })
    }
    if (callback) {
      callback({ found: _found, appUserAuths })
    } else {
      return { found: _found }
    }
  } catch (error) {
    console.error(error)
  }
}

const fsfn_getClientProfiles = async (fsCall, pathViews, emails, callback) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.getClientProfiles, pathViews, emails, showLogs: true }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    const { result } = response_data ?? {}
    if (callback) {
      callback(result)
    } else {
      return result
    }
  } catch (error) {
    console.error(error)
  }
}

const fsfn_getAuthsByEmail = async (appUsers, callback, index) => {
  try {
    const _appUsers = []
    Object.keys(appUsers).forEach(key => {
      const appUser = appUsers[key]
      const { email, phoneNumber } = appUser
      if (email || phoneNumber) {
        const _appUser = { email, phoneNumber }
        _appUsers.push(_appUser)
      }
    })
    const callData = { authFunctionType: authFunctionTypes.getAuthsByEmail, appUsers: _appUsers }
    const { result } = await callFsFunction(fsCall, callData) // OK
    if (callback) {
      callback(result)
    } else {
      return result
    }
  } catch (error) {
    console.error(error)
  }
}

const fsfn_getProfileAuth = async (fsCall, profileData, callback) => {
  const { email } = profileData
  try {
    const callData = { authFunctionType: authFunctionTypes.getAuthByEmail, email }
    const response_data = await callFsFunction(fsCall, callData) // OK  
    const { result: authData } = response_data ?? {}
    callback(profileData, authData)
  } catch (error) {
    console.error(error)
    callback({})
  }
}

/**
 * 
 * @param {object} itemData 
 * @param {function} callback
 * @description - adds a token (using setCustomUserClaims) to auth where email. No return needed 
 */
const fsfn_addAuthCustomToken = async (fsCall, itemData, callback) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.addAuthToken, ...itemData }
    const response_data = await callFsFunction(fsCall, callData) // OK
    if (callback) { callback(response_data) }
  } catch (error) {
    console.error(error)
  }
}

/** Deletes an auth user by uid */
const fsfn_deleteAuthByUid = async (fsCall, uid, dispatch, callback) => {
  try {
    const allowDelete = true
    if (allowDelete) {
      const callData = { authFunctionType: authFunctionTypes.deleteAuth, uid }
      const { success } = await callFsFunction(fsCall, callData) // OK
      if (dispatch) { dispatch({ type: success ? dispatchProps.success : dispatchProps.error }) }
      if (callback) { callback(success) }
    } else {
      console.log('fsfn_deleteAuthByUid', uid)
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} itemData 
 * @param {function} dispatch 
 * @param {function} callback 
 * @deprecated
 */
const fsfn_deleteAuthByEmail = async (fsCall, itemData, dispatch, callback) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.deleteAuthByEmail }
    const { success } = await callFsFunction(fsCall, callData) // OK
    if (dispatch) { dispatch({ type: success ? dispatchProps.success : dispatchProps.error }) }
    if (callback) { callback(success) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} uid 
 * @param {object} itemData 
 * @param {function} callback 
 * @deprecated
 */
const fsfn_disableAuth = async (fsCall, uid, itemData, callback) => {
  try {
    const { disabled } = itemData
    const data = { authFunctionType: authFunctionTypes.disableAuth, uid, disable: disabled }
    const { success } = await callFsFunction(fsCall, data) // OK
    if (callback) { callback(success) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} authUid 
 * @param {object} authData 
 * @param {function} callback 
 * @callback response_data
 */
const fsfn_updateAuthByUid = async (fsCall, authUid, authData, callback, projectName) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.updateAuthByUid, uid: authUid, authData, projectName }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    if (callback) { callback(response_data) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {*} authUid 
 * @param {*} authData 
 * @param {*} callback 
 * @deprecated
 */
const fsfn_removeFcm = async (fsCall, authUid, authData, callback) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.updateAuthByUid, uid: authUid, authData }
    const response_data = await callFsFunction(fsCall, callData) // OK
    if (callback) { callback(response_data) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {*} itemData 
 * @param {*} callback  
 * @param {*} returnResult 
 * @returns - the `result` object
 */
const fsfn_getAuthByEmail = async (fsCall, itemData, callback, projectName, useProd) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.getAuthByEmail, ...itemData, projectName }
    const { result } = await callFsFunction(fsCall, callData, useProd) // OK  
    if (callback) { callback(result) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {*} itemData 
 * @param {*} callback  
 * @param {*} returnResult 
 * @returns - the `result` object
 */
const fsfn_getAuthByPhoneNumber = async (fsCall, itemData, callback, projectName) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.getAuthByPhoneNumber, ...itemData, projectName }
    const { result } = await callFsFunction(fsCall, callData) // OK 
    if (callback) { callback(result) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {*} itemData 
 * @param {*} callback  
 * @param {*} returnResult 
 * @returns - the `result` object
 */
const fsfn_getAuthByEmailOrPhoneNumber = async (fsCall, itemData, callback) => {
  try {
    itemData.showLogs = true
    const callData = { authFunctionType: authFunctionTypes.getAuthByEmailOrPhoneNumber, ...itemData }
    const { result } = await callFsFunction(fsCall, callData) // OK 
    if (callback) { callback(result) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} itemData (uid, topic)
 * @param {function} dispatch 
 * @param {enum} dispatchType 
 * @returns Subscribes a user (via email or uid) to a topic using admin.messaging().subscribeToTopic
 */
const fsfn_addProfileTopic = async (fsCall, itemData, dispatch, dispatchType) => {
  // data: { email: any, topic: any; uid: any }

  try {
    const callData = { authFunctionType: authFunctionTypes.addProfileTopic, ...itemData }
    const response_data = await callFsFunction(fsCall, callData, true) // OK
    const { success } = response_data ?? {}
    if (dispatch) { dispatch({ type: success ? dispatchProps.success : dispatchProps.error }) }
    return response_data

  } catch (error) {
    console.error(error)
  }
}

const fsfn_removeProfileTopic = async (fsCall, itemData, dispatch, dispatchType) => {
  // data: { email: any, topic: any; }
  try {

  } catch (error) {
    console.error(error)
  }
  const callData = { authFunctionType: authFunctionTypes.removeProfileTopic, ...itemData }
  const response_data = await callFsFunction(fsCall, callData) // OK
  const { success } = response_data ?? {}
  if (dispatch) { dispatch({ type: success ? dispatchProps.success : dispatchProps.error }) }
}

const fnfs_createOrUpdateAuth = async (fsCall, itemData, dispatch) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.createOrUpdateAuth, ...itemData }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    const { success } = response_data ?? {}
    if (dispatch) { dispatch({ type: success ? dispatchProps.success : dispatchProps.error }) }
  } catch (error) {
    console.error(error)
  }
}

/** Updates the auth based on the email address  */
const fsfn_updateAuth = async (fsCall, itemData, dispatch) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.updateAuth, ...itemData }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success } = response_data ?? {}
    if (dispatch) { dispatch({ type: success ? dispatchProps.success : dispatchProps.error }) }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {*} itemData 
 * @returns  Updates the password of in auth based on the email address 
 * @deprecated
 */
const fsfn_updateAuthPassword = async (fsCall, itemData) => {
  try {
    const callData = { authFunctionType: authFunctionTypes.updateAuthPassword, ...itemData }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/** Gets the auth by email and then updates the auth password */
const fsfn_createOrUpdateAuthAndSignIn = async (fsCall, data) => {
  try {
    data.authFunctionType = authFunctionTypes.createOrUpdateAuth
    const response = await callFsFunction(fsCall, data) // OK
    return response
  } catch (error) {
    console.error(error)
  }
}

const fsfn_createCustomToken = async (fsCall, creds, dispatch) => {
  try {
    const { email: uid } = creds ?? {}
    const callData = { authFunctionType: authFunctionTypes.createCustomToken, uid }
    const response = await callFsFunction(fsCall, callData) // OK  
    if (dispatch) { dispatch(response) }
  } catch (error) {
    console.error(error)
  }
}

const chunkPromise = async (fsCall, chunks, pathViews, updateDatabase) => {
  const promises = []
  chunks.forEach(chunk => {
    const appUsers = []
    Object.keys(chunk).forEach(key => {
      const chunkItem = chunk[key]
      let { email, phoneNumber } = chunkItem ? chunkItem : {}
      email = email ? email.replace(/ /g, '') : null
      phoneNumber = phoneNumber ? phoneNumber.replace(/ /g, '') : null
      if ((email && !_.isEmpty(email)) || (phoneNumber && !_.isEmpty(phoneNumber))) {
        const item = {}
        if (email) { item.email = email.toLowerCase() }
        if (phoneNumber) { item.phoneNumber = phoneNumber }
        appUsers.push(item)
      }
    })
    // console.log('appUsers to check', _.size(appUsers), appUsers)
    const callData = { authFunctionType: authFunctionTypes.getAuthsByEmail, appUsers, pathViews, updateDatabase: false }
    promises.push(callFsFunction(fsCall, callData))
  })
  return Promise.all(promises)
} 